import { type ReactNode, useCallback, useState } from 'react';

import { PageViewLoadingContext } from '../../surfaces/page-view-loading';

/**
 * Collects inline-view activation on one preferences page into `waiting`.
 * The page paints a single spinner from that flag. Views that never report
 * do not hold it, and there is no timeout.
 */
export function PageViewLoadingProvider({
  children,
}: {
  children: (waiting: boolean) => ReactNode;
}): ReactNode {
  const [pending, setPending] = useState<ReadonlySet<string>>(() => new Set());
  const report = useCallback((viewId: string, loading: boolean) => {
    setPending((current) => {
      if (loading === current.has(viewId)) {
        return current;
      }
      const next = new Set(current);
      if (loading) {
        next.add(viewId);
      } else {
        next.delete(viewId);
      }
      return next;
    });
  }, []);
  return (
    <PageViewLoadingContext.Provider value={report}>
      {children(pending.size > 0)}
    </PageViewLoadingContext.Provider>
  );
}
